// extracted by mini-css-extract-plugin
export default {"metadata":"Metadata_metadata__s49CP"};